import { SystemConfigActionTypes } from '../../../types/systemConfig'
import { AppThunkAction } from '../../index'
import api from '../../../api'
import dayjs from 'dayjs'

export const getSystemConfig = (): AppThunkAction<Promise<void>> => {
	return async dispatch => {
		try {
			const configsResponse = await api.system.getConfigs()

			const configs = configsResponse.data?.result || []

			const configsObject: { [key: string]: any } = {}
			for (const item of configs) {
				if (item.entity === 'ui_tabs') {
					configsObject.uiTabs = item.data
				} else if (item.entity === 'drop_downs') {
					configsObject.dropDowns = (item.data as Array<any>).reduce(
						(acc, v: { type: string; data: [] }) => {
							acc[v.type] = v.data
							return acc
						},
						{} as { [key: string]: [] }
					)
				} else {
					configsObject[item.entity] = item.data
				}
			}

			if (configs.length) {
				dispatch({
					type: SystemConfigActionTypes.SYSTEM_CONFIGS_GET,
					payload: configsObject,
				})
			}
		} catch (e: any) {
			const error = e.message || ''

			throw new Error(error)
		}
	}
}

export const getUserSystemConfigData = (): AppThunkAction<Promise<void>> => {
	return async dispatch => {
		try {
			const timezoneOffsetInMinutes = -dayjs().utcOffset()
			const configsResponse = await api.user.getUserConfigData(timezoneOffsetInMinutes)

			const configs = configsResponse.data?.result || []
			dispatch({
				type: SystemConfigActionTypes.USER_CONFIG_DATA_GET,
				payload: configs,
			})
		} catch (e: any) {
			const error = e.message || ''

			throw new Error(error)
		}
	}
}